// src/pages/UpgradePage.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import './UpgradePage.css'; // You'll want to create some nice CSS for this page

function UpgradePage() {
  const navigate = useNavigate();

  const handleUpgradeClick = () => {
    // CHANGE: Navigate to the new payment page instead of showing an alert.
    navigate('/payment');
  };

  return (
    <div className="upgrade-page">
      <div className="upgrade-container">
        <header className="upgrade-header">
          <h1>✨ Upgrade to CourseHub Pro</h1>
          <p className="subtitle">Unlock your full potential with our most advanced AI-powered tools.</p>
        </header>

        <main className="pricing-section">
          <div className="plan-card">
            <h2>Pro Plan</h2>
            <div className="price">
              $4.99<span className="price-interval"> / 2 months</span>
            </div>
            <ul className="features-list">
              <li>✔️ Personalized chatbot</li>
              <li>✔️ Resume ingestion</li>
              <li>✔️ 100 chat conversations with chatbot per 2 month period</li>
            </ul>
            <button className="upgrade-button" onClick={handleUpgradeClick}>
              Upgrade Now
            </button>
          </div>
        </main>

        <footer className="upgrade-footer">
          <button onClick={() => navigate('/mentorai')} className="back-link">
            &larr; Go Back to Chat
          </button>
        </footer>
      </div>
    </div>
  );
}

export default UpgradePage;